import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { updateUserConfigurationAndService } from 'owa-userconfiguration/lib/utils/updateUserConfigurationAndService';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import saveOcsShowPreviewLinesSetting from '../utils/saveOcsShowPreviewLinesSetting';
import {
    setShowPreviewLinesOptionMutator,
    setTempPreviewLinesOptionMutator,
} from './setShowPreviewLinesOption';
import getDefaultPreviewLinesToShow from '../utils/getDefaultPreviewLinesToShow';

export default async function saveMessagePreviewOption(): Promise<void> {
    if (isFeatureEnabled('tri-mlMultiLinePreview-dev')) {
        const tempValue = store().tempPreviewLinesInListView;
        await onMessagePreviewSelection(tempValue);
    } else {
        await onMessagePreviewToggle(store().showPreviewTextInListView);
    }
}

export async function onMessagePreviewToggle(isEnabled: boolean | null): Promise<void> {
    const newValue = getFallbackValueIfNull(
        isEnabled,
        getUserConfiguration().UserOptions?.ShowPreviewTextInListView
    );

    await updateUserConfigurationAndService({
        UserOptions: {
            ShowPreviewTextInListView: newValue,
        },
    });
}

export async function onMessagePreviewSelection(linesToShow: number | null): Promise<void> {
    const savedValue: number = store().showPreviewLinesInListView ?? getDefaultPreviewLinesToShow();
    const newValue: number = getFallbackValueIfNull(linesToShow, savedValue);
    setShowPreviewLinesOptionMutator(newValue);
    setTempPreviewLinesOptionMutator(newValue);
    await saveOcsShowPreviewLinesSetting(newValue);
}
